import script from "./Step1GetOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1GetOrganization.vue?vue&type=script&setup=true&lang=js"

import "./Step1GetOrganization.vue?vue&type=style&index=0&id=2d59e434&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d59e434"]])

export default __exports__